import Vue from 'vue'
import * as msal from "@azure/msal-browser"
import {loginRequest, msalConfig} from "./authConfig";
import {b2cPolicies} from "./policies";

import store from "../../../store/index"
import {addToken} from "../../../api/user.api";
import {i18n, loadDictionaries} from "../../locales/i18n";
import {pages} from "../../constants/pages";
import routesNames from "../../constants/router/index";
import router from "../../../router/index";
import {handleGetMeResponse} from "../user";
import {handleApiErrors} from "../apiErrorHandler";

const MSALObj = new msal.PublicClientApplication(msalConfig);

MSALObj.handleRedirectPromise()
  .then(handleResponse)
  .catch(error => {
    console.log(error)
    // Check for forgot password error
    // Learn more about AAD error codes at https://docs.microsoft.com/en-us/azure/active-directory/develop/reference-aadsts-error-codes
    if (error.errorMessage.indexOf("AADB2C90118") > -1) {
      try {
        localStorage.clear();
        MSALObj.loginRedirect(b2cPolicies.authorities.forgotPassword);
      } catch(err) {
        console.log(err);
      }
    }
    // Check for cancelled entering self-asserted information error
    else if (error.errorMessage.indexOf("AADB2C90091") > -1) {
      localStorage.clear();
      signIn();
    }
    // Check for cancelled entering self-asserted information error
    else if (error.errorMessage.indexOf("AADB2C99002") > -1) {
      Vue.$snotify.error(
        i18n.t(pages.alerts.redirecting_to_login_page),
        i18n.t(pages.alerts.not_allowed_to_access)
      );
      setTimeout(() => {
        signIn();
      }, 5000)
    }
  });

function handleResponse(response) {
  /**
   * To see the full list of response object properties, visit:
   * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/request-response-object.md#response
   */
  if (response) {
    // for handling B2C user-flows and policies
    handlePolicyChange(response);
  }
}

function handlePolicyChange(response) {
  /**
   * We need to reject id tokens that were not issued with the default sign-in policy.
   * "acr" claim in the token tells us what policy is used (NOTE: for new policies (v2.0), use "tfp" instead of "acr").
   * To learn more about B2C tokens, visit https://docs.microsoft.com/en-us/azure/active-directory-b2c/tokens-overview
   */
  // We need to reject id tokens that were not issued with the default sign-in policy.
  // "acr" claim in the token tells us what policy is used (NOTE: for new policies (v2.0), use "tfp" instead of "acr")
  // To learn more about b2c tokens, visit https://docs.microsoft.com/en-us/azure/active-directory-b2c/tokens-overview
  if (response.idTokenClaims['acr'].toLowerCase() === b2cPolicies.names.forgotPassword.toLowerCase()) {
    localStorage.clear();
    MSALObj.loginRedirect(loginRequest);
  } else if (response.idTokenClaims['acr'].toLowerCase() === b2cPolicies.names.changePassword.toLowerCase()) {
    Vue.$snotify.success(i18n.t(pages.alerts.success_operation));
  } else if (response.idTokenClaims['acr'].toLowerCase() === b2cPolicies.names.SignIn.toLowerCase()) {
    addTokenToDatabase(response.account);
  }
}

function addTokenToDatabase(account) {
  store.dispatch("loader/beginAuthentication");
  localStorage.setItem("user_B2C_Account", JSON.stringify(account));
  store.commit("auth/setUserB2CAccount", account);
  const key = store.getters["auth/idTokenKey"];
  const token = JSON.parse(localStorage.getItem(key)).secret;
  addToken(token).then(
    (response) => {
      handleGetMeResponse(response)
      store.dispatch("loader/endAuthentication");
    },
    (error) => {
      if(error.response.status === 403){
        MSALObj.logoutRedirect({
          postLogoutRedirectUri: window.location.origin + "/not-allowed-page"
        });

      } else {
        handleApiErrors(error);
      }
      localStorage.clear()
      store.dispatch("loader/endAuthentication");
    }
  )
}

function signIn(redirectUri = null) {
  if (redirectUri) {
    loginRequest.redirectStartPage = redirectUri;
  }
  /**
   * You can pass a custom request object below. This will override the initial configuration. For more information, visit:
   * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/request-response-object.md#request
   */

  MSALObj.loginRedirect(loginRequest);
}

async function signOut() {

  /**
   * You can pass a custom request object below. This will override the initial configuration. For more information, visit:
   * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/request-response-object.md#request
   */
  await MSALObj.logoutRedirect({
    postLogoutRedirectUri: window.location.origin
  }).then(() => signIn());
}

function changePassword() {
  MSALObj.loginRedirect(b2cPolicies.authorities.changePassword)
}

function isAuthenticated() {
  return MSALObj.getAllAccounts().length;
}

function getAccount() {
  return JSON.parse(localStorage.getItem("user_B2C_Account"))
}


export {
  signIn,
  signOut,
  changePassword,
  isAuthenticated,
  getAccount,
  MSALObj
}
